"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatorRoundSchema = exports.calculatorDistrictSchema = exports.calculatorVariantSchema = exports.calculatorSchema = exports.calculatorBaseSchema = void 0;
const zod_1 = require("zod");
const calculatorGroupSchema = __importStar(require("./calculator-group.schema"));
const district_schema_1 = require("./district.schema");
const electionSchema = __importStar(require("./election.schema"));
const images_schema_1 = require("./images.schema");
const round_schema_1 = require("./round.schema");
const tags_schema_1 = require("./tags.schema");
const variant_schema_1 = require("./variant.schema");
const calculatorGroup = zod_1.z.lazy(() => calculatorGroupSchema.calculatorGroupSchemaReference).describe("Reference to a calculator group the calculator belongs to");
const election = zod_1.z.lazy(() => electionSchema.electionSchemaReference).describe("Reference to an election the calculator belongs to");
// Only a standalone calculator carries a key. A calculator in a group is identified by its coordinates within that group –
// district, variant and round – and its URL segment is composed from their keys, in that order.
const keySchema = zod_1.z
    .string()
    .regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)
    .describe("Human-friendly unique key of a calculator in the hyphen-separated lowercased format; forms the last URL segment");
const versionSchema = zod_1.z
    .string()
    .regex(/^\d+\.\d+\.\d+$/)
    .describe("Semantic version of the calculator");
const hashSchema = zod_1.z
    .object({
    algorithm: zod_1.z.literal("sha256"),
    value: zod_1.z.string().describe("Checksum value"),
})
    .strict();
const checksumsSchema = zod_1.z
    .object({
    questions: hashSchema.describe("Checksum of the questions data"),
})
    .strict()
    .describe("Checksums for calculator data");
const changeSchema = zod_1.z
    .object({
    version: zod_1.z
        .string()
        .regex(/^\d+\.\d+\.\d+$/)
        .describe("Semantic version of this change"),
    updatedAt: zod_1.z.string().datetime({ offset: true }),
    title: zod_1.z.string().optional(),
    description: zod_1.z.string().optional(),
})
    .strict();
const changesSchema = zod_1.z.array(changeSchema).describe("Change history of the calculator");
exports.calculatorBaseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid().describe("Unique identifier of a calculator in the format of UUID"),
    createdAt: zod_1.z.string().datetime({ offset: true }).describe("Time of the creation of a calculator in the ISO 8601 format"),
    updatedAt: zod_1.z.string().datetime({ offset: true }).describe("Time of the last update of a calculator in the ISO 8601 format").optional(),
    publishedAt: zod_1.z.string().datetime({ offset: true }).describe("Time when a calculator should be published in the ISO 8601 format").optional(),
    title: zod_1.z.string().describe("Title of a calculator").optional(),
    description: zod_1.z.string().describe("Description of a calculator").optional(),
    methodology: zod_1.z.string().describe("Methodology of a calculator").optional(),
    intro: zod_1.z.string().describe("Intro text displayed before starting the calculator").optional(),
    tags: tags_schema_1.tagsSchema.describe("Tags of a calculator").optional(),
    images: images_schema_1.imagesSchema.describe("Images associated with the calculator").optional(),
    version: versionSchema.optional(),
    checksums: checksumsSchema.optional(),
    changes: changesSchema.optional(),
});
const standaloneCalculatorSchema = exports.calculatorBaseSchema
    .extend({
    key: keySchema,
    shortTitle: zod_1.z.string().max(25).describe("Short title of a calculator with a maximum of 25 characters"),
    election: election.optional(),
})
    .strict();
const groupCalculatorSchema = exports.calculatorBaseSchema
    .extend({
    calculatorGroup: calculatorGroup,
    variant: variant_schema_1.variantReferenceSchema,
    shortTitle: zod_1.z.string().max(25).describe("Short title of a calculator with a maximum of 25 characters").optional(),
})
    .strict();
const electionCalculatorSchema = exports.calculatorBaseSchema
    .extend({
    calculatorGroup: calculatorGroup,
    election: election,
    shortTitle: zod_1.z.string().max(25).describe("Short title of a calculator with a maximum of 25 characters").optional(),
    variant: variant_schema_1.variantReferenceSchema.optional(),
    district: district_schema_1.districtReferenceSchema.optional(),
    round: round_schema_1.roundReferenceSchema.optional(),
})
    .strict()
    .superRefine((data, ctx) => {
    if (!(data.variant || data.district || data.round)) {
        const message = "Election calculator must have at least a variant, district, or round";
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, message, path: ["variant"] });
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, message, path: ["district"] });
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, message, path: ["round"] });
    }
});
exports.calculatorSchema = standaloneCalculatorSchema.or(groupCalculatorSchema).or(electionCalculatorSchema).describe("Calculator is a set of questions, candidates and their answers");
exports.calculatorVariantSchema = variant_schema_1.variantReferenceSchema;
exports.calculatorDistrictSchema = district_schema_1.districtReferenceSchema;
exports.calculatorRoundSchema = round_schema_1.roundReferenceSchema;
